import { createContext, useContext } from "react"
import { chPatientByIdQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientByIdQuery.graphql"
import { dePatientByIdQuery$data } from "@/modules/patients/services/de/__generated__/dePatientByIdQuery.graphql"

interface PatientLayoutContextValue {
  countryPatient:
    | NonNullable<dePatientByIdQuery$data["patientById"]>
    | NonNullable<chPatientByIdQuery$data["patientById"]>
}

const PatientLayoutContext = createContext<PatientLayoutContextValue | null>(null)

type PatientLayoutProviderProps = React.PropsWithChildren<PatientLayoutContextValue>

export const PatientLayoutProvider = ({ children, countryPatient }: PatientLayoutProviderProps) => {
  return (
    <PatientLayoutContext.Provider
      value={{
        countryPatient,
      }}>
      {children}
    </PatientLayoutContext.Provider>
  )
}

export function usePatientLayoutContext(): PatientLayoutContextValue {
  const context = useContext(PatientLayoutContext)
  if (!context) throw new Error("Missing PatientLayoutProvider in the tree")
  return context
}
